import { render, staticRenderFns } from "./TelefonoCompleto.vue?vue&type=template&id=527f8f32"
import script from "./TelefonoCompleto.vue?vue&type=script&lang=js"
export * from "./TelefonoCompleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports